// src/Views/HomePage.js
import React, { useState } from 'react';
import './HomePage.css';
import TopFold from './TopFold.js';
import Enterprise from './Enterprise.js';
import Footer from './Footer.js';


import Newsletter from './Newsletter.js';
const HomePage = () => {
    const [isBlue, setIsBlue] = useState(false);

    const toggleColor = () => {
        setIsBlue(!isBlue);
    };

    return (
        <div className="cafe-homepage">
            <TopFold />
            <Enterprise />
            <Newsletter />
            <Footer />
        </div>
    );
};

export default HomePage;